import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React from "react";
import classnames from "classnames";
import "./Icon.scss";
import config from "../../config";
var icons = config.get("style.icons");
export var Icon = function Icon(a) {
  var b = a.tag,
      c = void 0 === b ? "span" : b,
      d = a.icon,
      e = a.size,
      f = a.children,
      g = a.href,
      h = a.style,
      i = a.className,
      j = a.title,
      k = a.external,
      l = _objectWithoutProperties(a, ["tag", "icon", "size", "children", "href", "style", "className", "title", "external"]),
      m = icons[d];

  return /*#__PURE__*/React.createElement(React.Fragment, null, k ? /*#__PURE__*/React.createElement(c, Object.assign({
    className: classnames("ta-icon", i, _defineProperty({}, "ta-icon-".concat(e), e)),
    style: _objectSpread({}, h, {
      backgroundImage: "url(".concat(m, ")")
    }),
    href: g,
    title: j && j.replace("_", " ")
  }, l, {
    target: "_blank",
    rel: "noopener noreferrer"
  }), f) : /*#__PURE__*/React.createElement(c, Object.assign({
    className: classnames("ta-icon", i, _defineProperty({}, "ta-icon-".concat(e), e)),
    style: _objectSpread({}, h, {
      backgroundImage: "url(".concat(m, ")")
    }),
    href: g,
    title: j && j.replace("_", " ")
  }, l), f));
};
export default Icon;